import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { initialEpidemiology } from '@app/dp-shared';
import { _className, Grid, LL_V_L, TS_PropRenderer } from '@nu-art/thunderstorm-frontend';
import './Editor_DiseaseProfile_Epidemiology.scss';
import { FadeScrollWrapper, ICONS } from '@app/styles';
import { DefaultEditor_TextArea } from '@app/styles/frontend/ui-manager/ui-components';
import { cloneObj } from '@nu-art/ts-common';
import { Component_EpidemiologyItemEditor } from '../../../../../../components/Component_EpidemiologyEditor/Component_EpidemiologyItemEditor.js';
const Field_EpidemiologyNotes = (props) => {
    return _jsx(TS_PropRenderer.Horizontal, { label: 'Notes', children: _jsx(DefaultEditor_TextArea, { editable: props.editable, prop: 'epidemiologyNotes', disabled: !props.editMode }) });
};
const Field_Epidemiology = (props) => {
    const editable = props.editable.editProp('epidemiology', []);
    const addEpidemiology = () => {
        const newEpidemiology = cloneObj(initialEpidemiology);
        editable.updateArrayAt(newEpidemiology);
    };
    return _jsx(TS_PropRenderer.Horizontal, { label: 'Epidemiology', children: _jsxs(LL_V_L, { className: 'e__disease-profile__epidemiology-items', children: [editable.item.map((ref, index) => {
                    const editableEpidemiology = editable.editProp(index, {});
                    editableEpidemiology.setOnDelete(async () => editable.removeArrayItem(index));
                    return _jsx(Component_EpidemiologyItemEditor, { editable: editableEpidemiology, editMode: props.editMode, withRemoveIcon: true }, index);
                }), props.editMode && _jsx(ICONS.advisor_avn_add.component, { onClick: addEpidemiology })] }) });
};
export const Editor_DiseaseProfile_Epidemiology = (props) => {
    const className = _className('e__disease-profile__epidemiology', props.editMode && 'edit-mode');
    return _jsx(FadeScrollWrapper, { className: className, children: _jsxs(Grid, { children: [_jsx(Field_EpidemiologyNotes, { ...props }), _jsx(Field_Epidemiology, { ...props })] }) });
};
//# sourceMappingURL=Editor_DiseaseProfile_Epidemiology.js.map